import {
    TransactionColumn,
    type TransactionView,
} from "@common/types/views/transactionViews";
import { BulkUpdateParams } from "../../transactions/TransactionsBulkActions/lib";

export const NEW_VALUE_COLUMN_ID = TransactionColumn.NEW_VALUE;

type SimilarTransactionsUpdateColumn = Extract<
    TransactionView["columns"][number],
    | { id: TransactionColumn.CATEGORY }
    | { id: TransactionColumn.COUNTERPARTY }
    | { id: TransactionColumn.CUSTOMER }
    | { id: TransactionColumn.LEDGER }
    | { id: TransactionColumn.ACCRUAL_LEDGER }
    | { id: TransactionColumn.CLASSES }
    | { id: TransactionColumn.ENTITY }
>;

const UPDATE_COLUMNS: Partial<
    Record<BulkUpdateParams["update"], SimilarTransactionsUpdateColumn>
> = {
    categoryId: { id: TransactionColumn.CATEGORY },
    counterpartyId: { id: TransactionColumn.COUNTERPARTY },
    customerId: { id: TransactionColumn.CUSTOMER },
    coa: { id: TransactionColumn.LEDGER },
    accrualCoa: { id: TransactionColumn.ACCRUAL_LEDGER },
    classes: { id: TransactionColumn.CLASSES },
    entity: { id: TransactionColumn.ENTITY },
};

const PROPERTY_LABELS: Record<BulkUpdateParams["update"], string> = {
    categoryId: "category",
    counterpartyId: "counterparty",
    customerId: "customer",
    coa: "general ledger",
    accrualCoa: "accrual account",
    classes: "class",
    entity: "entity",
    memo: "memo",
    taxQuestionAnswers: "tax question",
    pairedTransferId: "transfer",
    excludeFrom1099: "1099 exclusion",
};

export function getPropertyLabel(update: BulkUpdateParams["update"]): string {
    return PROPERTY_LABELS[update] ?? update;
}

export function getTransactionColumnForUpdate(
    update: BulkUpdateParams["update"],
): SimilarTransactionsUpdateColumn | undefined {
    return UPDATE_COLUMNS[update];
}

export function getTransactionColumnIdForUpdate(
    update: BulkUpdateParams["update"],
): TransactionColumn | undefined {
    return getTransactionColumnForUpdate(update)?.id;
}
